import React from "react";
import { Search, SlidersHorizontal } from "lucide-react";

export function SearchBar({ value, onChange, placeholder = "Search", onFilter, testid, autoFocus = false }) {
  return (
    <div className="flex items-center gap-2">
      <div className="relative flex-1">
        <Search className="w-4 h-4 absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400" strokeWidth={2.4} />
        <input
          data-testid={testid || "vc-search-input"}
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
          placeholder={placeholder}
          autoFocus={autoFocus}
          className="w-full h-11 pl-10 pr-4 rounded-2xl bg-slate-50 border border-transparent focus:border-emerald-300 focus:bg-white outline-none text-sm placeholder:text-slate-400 transition"
        />
      </div>
      {onFilter && (
        <button
          data-testid="vc-search-filter"
          onClick={onFilter}
          className="w-11 h-11 rounded-2xl bg-slate-50 hover:bg-slate-100 grid place-items-center text-slate-600 transition"
        >
          <SlidersHorizontal className="w-4 h-4" strokeWidth={2.4} />
        </button>
      )}
    </div>
  );
}
